(function () {
  function revealElement(element) {
    element.classList.add('is-visible');
  }

  function initScrollAnimations() {
    const animatedItems = document.querySelectorAll('.scroll-animate:not(.is-visible)');

    if (!animatedItems.length) return;

    if (!('IntersectionObserver' in window)) {
      animatedItems.forEach(revealElement);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealElement(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.05,
        rootMargin: '0px 0px -20px 0px'
      }
    );

    animatedItems.forEach(function (item) {
      const rect = item.getBoundingClientRect();

      // If already visible when script runs, reveal immediately.
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        revealElement(item);
      } else {
        observer.observe(item);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initScrollAnimations);
  window.addEventListener('load', initScrollAnimations);

  document.addEventListener('shopify:section:load', initScrollAnimations);
  document.addEventListener('shopify:block:select', initScrollAnimations);
  document.addEventListener('shopify:section:select', initScrollAnimations);

  // Handles Horizon/theme blocks that are injected or re-rendered after load.
  const mutationObserver = new MutationObserver(function () {
    initScrollAnimations();
  });

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();